<template>
  <div>
    <b-modal
      id="duplicate-ticket-modal"
      size="xl"
      hide-footer
      no-close-on-backdrop
    >
      <b-card-text>
        <!-- START ROW Log -->
         <h2 class="text-danger">มี Site นี้อยู่ในหน้าต่าง Inprogress แล้ว</h2>
        <b-row class="mt-2">
          <b-col md="12 ">
            <b-table
              class="shadow"
              style="font-size: 12px"
              small
              striped
              bordered
              hover
              :items="ticketList"
              :fields="fields"
              :busy="isLoading"              
            >
              <template #cell(no)="row">
                {{ row.index + 1 }}
              </template>
              <template #cell(openTicketDate)="row">
                {{ showDate(row.item.openTicketDate, "original") }}
              </template>

              <template #cell(selected)="{ rowSelected }"></template>

              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>      
        <!-- END ROW Log -->

        <b-row class="mt-2">
          <b-col class="d-flex justify-content-end align-items-center">
            <b-button
              variant="danger"
              size="sm"
              style="height: 35px"
              class="mr-1"
              @click="onClear"
            >
              ยกเลิก
            </b-button>

            <b-button
              variant="primary"
              size="sm"
              style="height: 35px"
              class="mr-1"
              @click="onConfirm"
            >
              ดำเนินการต่อ
            </b-button>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import { VBModal, BCardText, BRow, BCol, BTable, BInputGroup,BFormInput, BInputGroupAppend, BButton } from "bootstrap-vue";
export default {
  props: ["ticketList"],
  components: { BCardText, BRow, BCol, BTable, BInputGroup,BFormInput, BInputGroupAppend, BButton },
  directives: {
    "b-modal": VBModal,
  },
  computed: {
    dialog() {
      return this.isShowModal;
    },
  },
  watch: {
    dialog() {
      return this.isShowModal;
    },
  },
  data() {
    return {
      fields: [
        {
          key: "branchCode",
          label: "Site ID",
          thStyle:{color:"white", textAlign: "center"}
        },
        { key: "branchName", label: "Site Name", sortable: true , thStyle:{color:"white", textAlign: "center"}},
        { key: "ticketNo", label: "Job No", sortable: true ,thStyle:{color:"white",width: "8% !important", textAlign: "center"}},
        { key: "openTicketDate", label: "Open Date", sortable: true , thStyle:{color:"white", textAlign: "center"}},
        { key: "problemTypeName", label: "Problem type", sortable: false , thStyle:{color:"white", textAlign: "center"}},
        {
          key: "problemDetail",
          label: "Problem",
          sortable: false,
          thStyle: { width: "30% !important", textAlign: "center" ,color:"white"},
        },
        { key: "assignTo", label: "Resolve by", sortable: false ,thStyle:{color:"white", textAlign: "center", width: "7% !important"}},
        {
          key: "remark",
          label: "Remark",
          sortable: false,
          thStyle: { width: "15% !important", textAlign: "center", color:"white" },
        },
      ],        
      isLoading:false,     
    
    };
  },

  methods: {
    showDate(date, type = "") {
      if (type == "date") {
        return moment(date).format("DD-MM-yyyy");
      }

      if (type == "original") {
        return moment(date).subtract(7, "h").format("DD-MM-yyyy HH:mm:ss");
      }

      if (type == "subtract") {
        return moment(date).subtract(7, "h");
      }

      return moment(date).format("DD-MM-yyyy HH:mm:ss");
    },
    onClear() {      
      this.$emit("onClear");
      this.$bvModal.hide("duplicate-ticket-modal")
    },
    onConfirm() {      
      this.$emit("onConfirm");
      this.$bvModal.hide("duplicate-ticket-modal")
    },
  },

  mounted() {},
};
</script>

<style>
@import "./style.css";
</style>
